import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class BedsideTableFrontToSimpleSapElementMapper
    extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const type = this.formatType('FRS', 1, 1);
        const color = this.toColor(element);
        return [SimpleSapElement.ELEMENT(type, color)];
    }
}